import { createRatesEnterpriseRequest } from "../../data/ratesEnterpriseApi";
import { validateTarifaEnterprisePayload } from "../validator/validateTarifaEnterprisePayload";

export async function createTarifaEnterpriseUseCase(payload) {
  const error = validateTarifaEnterprisePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createRatesEnterpriseRequest(payload);
}
